/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import VisibilityIcon from "@material-ui/icons/Visibility";
import BlockIcon from "@material-ui/icons/Block";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditOrganizationPage,
    allowEdit,
    openOrganizationFilePage,
    setCurrentOrg,
    setModal
  }
) => (
  <div className="d-flex">
    <OverlayTrigger
      overlay={<Tooltip id="products-edit-tooltip">Lihat Dokumen</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-info btn-sm mx-1"
        onClick={() => openOrganizationFilePage(row.uuid)}
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          <InsertDriveFileIcon />
        </span>
      </a>
    </OverlayTrigger>

    <OverlayTrigger
      overlay={<Tooltip id="products-edit-tooltip">Detail Lembaga</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
        onClick={() => openEditOrganizationPage(row.uuid)}
      >
        {row.id}
        <span className="svg-icon svg-icon-md svg-icon-primary">
          {/* <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
          /> */}
          <VisibilityIcon />
        </span>
      </a>
    </OverlayTrigger>
    {allowEdit && row.start_date && (
      <OverlayTrigger
        overlay={
          <Tooltip id="products-edit-tooltip">
            {row.is_activated ? "NON AKTIFKAN" : "AKTIFKAN"}
          </Tooltip>
        }
      >
        <a
          className={`btn btn-icon btn-light btn-hover-${
            row.is_activated ? "danger" : "success"
          } btn-sm mx-1`}
          onClick={() => {
            setCurrentOrg(row);
            if (row.is_activated) {
              setModal(prev => ({
                ...prev,
                activated: false,
                inactive: true
              }));
            } else {
              setModal(prev => ({
                ...prev,
                activated: true,
                inactive: false
              }));
            }
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            {row.is_activated ? <BlockIcon /> : <CheckCircleIcon />}
          </span>
        </a>
      </OverlayTrigger>
    )}
  </div>
);
